import React, { useState, useMemo } from 'react';
import CaptureImageListner from './CaptureImageListener';
import ParticipantView from './ParticipantView';
import Controls from './Controls';
import { useMeeting } from "@videosdk.live/react-sdk";
import styles from "../PD/pd.module.css";
import ControlWebCam from './ControlWebCam';
import { ToastContainer, toast } from "react-toastify";

const MeetingView = ({ meetingId, onMeetingLeave, loanID }) => {
    const FullName = sessionStorage.getItem("fullName")
    const UserName = sessionStorage.getItem("formattedUserName")
    const LoanId = sessionStorage.getItem("LoanID")

    const [joined, setJoined] = useState(null);
    const [largeParticipantId, setLargeParticipantId] = useState(null);

    const { join, participants } = useMeeting({
        onMeetingJoined: () => {
            setJoined("JOINED");
        },
        onMeetingLeft: () => {
            onMeetingLeave();
        },
        webcamConfig: {
            resolution: "fullhd",        // "sd" | "hd" | "fullhd"
            optimizationMode: "motion", // "motion" | "detail"

        },
    });

    const joinMeeting = () => {
        setJoined("JOINING");
        join();
    };

    const meetingUrl = `${window.location.href}/pd?meetingId=${meetingId}&name=${FullName}&Username=${UserName}&loanId=${LoanId}`;

    // Create videoRefs per participant
    const videoRefs = useMemo(() => {
        const refs = {};
        [...participants.keys()].forEach((id) => {
            refs[id] = React.createRef();
        });
        return refs;
    }, [participants]);

    // Create micRefs per participant
    const micRefs = useMemo(() => {
        const refs = {};
        [...participants.keys()].forEach((id) => {
            refs[id] = React.createRef();
        });
        return refs;
    }, [participants]);

    const handleParticipantClick = (participantId) => {
        setLargeParticipantId(participantId);
    };

    const copyToClipboard = (text) => {
        navigator?.clipboard?.writeText(text)
            .then(() => {
                toast.success("Meeting Url Copied")
            })
            .catch((err) => {
                toast.error("Failed to copy")
                console.log(err);
            });
    };

    return (
        <div className={joined === "JOINED" ? styles.meetingJoinContainer : styles.meetingParentContainer}>
            <div className={joined === "JOINED" ? styles.meetingJoinContainer : styles.meetingContainer}>
                <div className={styles.meetingContentWrapper}>
                    <div className={styles.urlRow}>
                        <h3>Meeting Url: </h3>
                    </div>
                    <button
                        onClick={() => copyToClipboard(meetingUrl)}
                        className={styles.copyButton}                      >
                        Copy Meeting Url
                    </button>
                </div>

                {joined === "JOINED" ? (
                    <>
                        <Controls loanID={loanID} />
                        {[...participants.keys()].map((localParticipantId) => (
                            <CaptureImageListner
                                loanID={loanID}
                                localParticipantId={localParticipantId}
                                key={localParticipantId}
                                videoRef={videoRefs[localParticipantId]}
                            />
                        ))}

                        {largeParticipantId && (
                            <ControlWebCam
                                loanID={loanID}
                                localParticipantId={largeParticipantId}
                                key={largeParticipantId}
                            />
                        )}

                        {[...participants.keys()].map((participantId) => (
                            <ParticipantView
                                participantId={participantId}
                                key={participantId}
                                isLarge={largeParticipantId === participantId}
                                onClick={handleParticipantClick}
                                videoRef={videoRefs[participantId]}
                                micRef={micRefs[participantId]}
                                loanID={loanID}
                                meetingId={meetingId}
                            />
                        ))}
                    </>
                ) : joined === "JOINING" ? (
                    <p>Joining the Meeting...</p>
                ) : (
                    <button className={styles.joinBtnMeeting} onClick={joinMeeting}>Join</button>
                )}
            </div>
            <ToastContainer />
        </div>
    );
};

export default MeetingView;